import { RapidReconIcon } from '@/components/deal/vehicle/rapid-recon-step/rapid-recon-step-badge';
import type { RapidReconStep } from '@/models/types';
import RapidReconStepFiltersComboBoxPopover from '../combobox-popovers/rapid-recon-step-filters-combobox-popover';
import {
  type RapidReconStepFilterChipProps,
  type RapidReconStepFiltersState,
} from '../types';
import BaseFilterChip from './base-filter-chip';

const RapidReconStepFilterChip = (props: RapidReconStepFilterChipProps) => {
  const {
    filtersState,
    setFiltersState,
    deleteFilter,
    shouldDeleteWhenNoFiltersAreSelected,
  } = props;

  return (
    <BaseFilterChip<RapidReconStep, RapidReconStepFiltersState>
      filtersState={filtersState}
      setFiltersState={setFiltersState}
      FiltersComboBoxPopover={RapidReconStepFiltersComboBoxPopover}
      deleteFilter={deleteFilter}
      representativeIcon={<RapidReconIcon />}
      filterName="Rapid Recon Step"
      filterQuantifier={{
        singular: 'rapid recon step',
        plural: 'rapid recon steps',
      }}
      SelectedFilterBadge={() => <RapidReconIcon />}
      shouldDeleteWhenNoFiltersAreSelected={
        shouldDeleteWhenNoFiltersAreSelected
      }
    />
  );
};

export default RapidReconStepFilterChip;
